import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import TopBar from './TopBar';
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: (theme.palette.background as any).dark,
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        width: '100%'
    },
}));
type Props = {
    children?: any;
    workflowTab?: string,
};

function BasicLayout({ children, workflowTab }: Props) {
    const classes = useStyles();
    return (<Box className={classes.root}>
      <TopBar workflowTab={workflowTab}/>
      <Box display="flex" width="100%" height="100%" pt="64px">
        <PerfectScrollbar style={{ width: '100%' }} options={{ suppressScrollX: true }}>
          <Box display="flex" width="100%" height="100%">
            {children}
          </Box>
        </PerfectScrollbar>
      </Box>
    </Box>);
}
export default BasicLayout;
